import { Button } from "@mui/material";
import { useFormik } from "formik";
import { useMutation, useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";


import { getYoutubeFolderFn, getYoutubeLinkByIdFn, patchYoutubeLinkFn, postYoutubeLinkFn } from "../../../../Services/Youtube";

export default function AddYoutubeLinks() {
  const { state: locationState } = useLocation();
  const { state: status } = useParams();

  const navigate = useNavigate();

  const { data: fetchedData } = useQuery({
    queryKey: ["get-youtube-link-by-id", locationState, status === "update"],
    queryFn: () => getYoutubeLinkByIdFn(locationState?.link_id),
    enabled: !!locationState?.link_id && status === "update",
  });

  const { data: getGallery } = useQuery({
    queryKey: ["get-category-by-id"],
    queryFn: getYoutubeFolderFn,
  });


  const { mutate: postImageGallery } = useMutation(postYoutubeLinkFn, {
    onSuccess: (response) => {
      if (response.data?.response_code === 200) {
        toast.success("Added New Link");
        navigate(-1);
      }
    },
  });

  const { mutate: patchGalleryImage } = useMutation(patchYoutubeLinkFn, {
    onSuccess: (response) => {
      if (response.data?.response_code === 200) {
        toast.success("Updated Link");
        navigate(-1);
      }
      if (response.data?.response_code === 201) {
        toast.success(response.data?.message);
      }
    },
  });

  const data = fetchedData?.data?.data;

  const formik = useFormik({
    initialValues: {
      title: data?.title || "",
      gallery: data?.gallery || "",
      url: data?.url || "",
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log(values);
      const formData = new FormData();
      formData.append("title", values.title);
      formData.append("url", values.url);
      formData.append("video", locationState?.video_id);

      if (locationState?.link_id && status === "update") {
        formData.append("video_url_id", locationState?.link_id);
        // if (!values.image) formData.delete("image");
        patchGalleryImage(formData);
      } else {
        if (!values.url) return toast.error("Url is required");

        postImageGallery(formData);
      }
    },
  });

  console.log(formik.values);

  return (
    <div className="flex flex-col justify-center gap-5 py-4 lg:flex-row">
      <div className="flex flex-col justify-center w-full lg:w-3/5">
        <div className="mt-5 bg-white shadow-lg">
          <form onSubmit={formik.handleSubmit}>
            <div className="p-2 border-gray-300 rounded-md">
              <div className="flex flex-col gap-5">
                {/* <div className="  w-full pl-3">
                  <p className="p-1 text-sm font-semibold">Gallery</p>
                  <select
                    className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                    name="gallery"
                    value={formik.values.gallery}
                    onChange={formik.handleChange}
                  >
                    <option value="" disabled hidden>
                      Select Gallery
                    </option>
                    {getGallery?.data?.data.map((subCat) => (
                      <option key={subCat.id} value={subCat.id}>
                        {subCat.title}
                      </option>
                    ))}
                  </select>

                </div> */}
                <div className="w-full pl-3">
                  <div>
                    <p className="p-1 text-sm font-semibold">Title</p>
                    <input
                      id="title"
                      placeholder="Enter title"
                      value={formik.values.title}
                      className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>
                <div className="w-full pl-3">
                  <div>
                    <p className="p-1 text-sm font-semibold">Url</p>
                    <input
                      id="image"
                      type="text"
                      value={formik.values.url}
                      className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                      onChange={(event) =>
                        formik.setFieldValue("url", event.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="w-full pl-3">
                  <Button type="submit" variant="contained">
                    {status === "update" ? "Update" : "Add"}
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
